import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { CircularProgress, Typography } from '@material-ui/core';

import CustomButton from 'components/Button';
import { ICustomTheme } from 'interfaces';

const Container = styled.div(({ theme }: { theme: ICustomTheme }) => ({
  marginTop: theme.spacing(4),
}));

const Title = styled(Typography)(({ theme }: { theme: ICustomTheme }) => ({
  textAlign: 'center',
  fontWeight: theme.typography.fontWeightBold,
  color: theme.colors.grey.dark,
}));

const Content = styled(Typography)(({ theme }: { theme: ICustomTheme }) => ({
  textAlign: 'center',
  marginTop: theme.spacing(2),
  color: theme.colors.grey.dark,
}));

const ButtonContainer = styled.div(({ theme }: { theme: ICustomTheme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(2),
  '& button': {
    width: 330,
    '&:hover svg': {
      color: theme.colors.paletteFromBO.main,
    },
  },
}));

const Spinner = styled(CircularProgress)(
  ({ theme }: { theme: ICustomTheme }) => ({
    marginRight: theme.spacing(1),
    color: theme.colors.white,
  }),
);

interface IInvalidResetPasswordLink {
  isLoading: boolean;
  hasError: boolean;
  onEmailSend: () => void;
}

export default function InvalidResetPasswordLink({
  isLoading,
  hasError,
  onEmailSend,
}: IInvalidResetPasswordLink) {
  const { t } = useTranslation();

  return hasError ? (
    <Container>
      <Title>{t('auth.reset_password.invalidLink')}</Title>
    </Container>
  ) : (
    <Container>
      <Title>{t('auth.reset_password.expiredLink')}</Title>
      <Content variant="body2">
        {t('auth.reset_password.receiveNewEmailMessage')}
      </Content>
      <ButtonContainer>
        <CustomButton onClick={onEmailSend}>
          {isLoading && <Spinner size="2.5rem" />}
          {t('auth.reset_password.receiveNewEmailButton')}
        </CustomButton>
      </ButtonContainer>
    </Container>
  );
}
